"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5652],{

/***/ 5724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17058);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 96 96"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("image", {
            href: "/images/pulse-chain-logo.svg",
            width: "96px",
            height: "96px"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 86770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17058);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M19.43 12.98C19.47 12.66 19.5 12.34 19.5 12C19.5 11.66 19.47 11.34 19.43 11.02L21.54 9.37C21.73 9.22 21.78 8.95 21.66 8.73L19.66 5.27C19.54 5.05 19.27 4.97 19.05 5.05L16.56 6.05C16.04 5.65 15.48 5.32 14.87 5.07L14.49 2.42C14.46 2.18 14.25 2 14 2H9.99996C9.74996 2 9.53996 2.18 9.50996 2.42L9.12996 5.07C8.51996 5.32 7.95996 5.66 7.43996 6.05L4.94996 5.05C4.71996 4.96 4.45996 5.05 4.33996 5.27L2.33996 8.73C2.20996 8.95 2.26996 9.22 2.45996 9.37L4.56996 11.02C4.52996 11.34 4.49996 11.67 4.49996 12C4.49996 12.33 4.52996 12.66 4.56996 12.98L2.45996 14.63C2.26996 14.78 2.21996 15.05 2.33996 15.27L4.33996 18.73C4.45996 18.95 4.72996 19.03 4.94996 18.95L7.43996 17.95C7.95996 18.35 8.51996 18.68 9.12996 18.93L9.50996 21.58C9.53996 21.82 9.74996 22 9.99996 22H14C14.25 22 14.46 21.82 14.49 21.58L14.87 18.93C15.48 18.68 16.04 18.34 16.56 17.95L19.05 18.95C19.28 19.04 19.54 18.95 19.66 18.73L21.66 15.27C21.78 15.05 21.73 14.78 21.54 14.63L19.43 12.98ZM12 15.5C10.07 15.5 8.49996 13.93 8.49996 12C8.49996 10.07 10.07 8.5 12 8.5C13.93 8.5 15.5 10.07 15.5 12C15.5 13.93 13.93 15.5 12 15.5Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 85714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17058);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M13 3C8.03 3 4 7.03 4 12H2.20711C1.76165 12 1.53857 12.5386 1.85355 12.8536L4.54604 15.546C4.73751 15.7375 5.04662 15.7418 5.24329 15.5556L8.08805 12.8631C8.4164 12.5524 8.19646 12 7.74435 12H6C6 8.13 9.13 5 13 5C16.87 5 20 8.13 20 12C20 15.87 16.87 19 13 19C11.4314 19 9.98175 18.4782 8.81739 17.601C8.37411 17.267 7.74104 17.259 7.3486 17.6514C6.95725 18.0428 6.95413 18.6823 7.38598 19.0284C8.92448 20.2615 10.8708 21 13 21C17.97 21 22 16.97 22 12C22 7.03 17.97 3 13 3ZM12 8V13L16.28 15.54L17 14.33L13.5 12.25V8H12Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 86921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Transactions_TransactionsModal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(64011);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/Modal.tsx
var Modal = __webpack_require__(90452);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/styles.tsx
var styles = __webpack_require__(9355);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(96293);
// EXTERNAL MODULE: ./src/contexts/Localization/index.tsx + 3 modules
var Localization = __webpack_require__(99150);
// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(75472);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
// EXTERNAL MODULE: ./src/state/transactions/hooks.tsx
var hooks = __webpack_require__(55892);
// EXTERNAL MODULE: ./src/state/index.ts + 19 modules
var state = __webpack_require__(31318);
// EXTERNAL MODULE: ./src/state/transactions/actions.ts
var actions = __webpack_require__(81564);
// EXTERNAL MODULE: ./src/components/Layout/Row.tsx
var Row = __webpack_require__(39475);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/LinkExternal.tsx
var LinkExternal = __webpack_require__(10566);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Checkmark.tsx
var Checkmark = __webpack_require__(60526);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Close.tsx
var Close = __webpack_require__(92510);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(93293);
// EXTERNAL MODULE: ./src/components/Loader/CircleLoader.tsx
var CircleLoader = __webpack_require__(28630);
;// CONCATENATED MODULE: ./src/components/App/Transactions/Transaction.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  text-decoration: none !important;\n  border-radius: 0.5rem;\n  padding: 0.25rem 0rem;\n  font-weight: 500;\n  font-size: 0.825rem;\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var TransactionState = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8aaa60d2-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var IconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8aaa60d2-1"
})(_templateObject1(), function(param) {
    var pending = param.pending, success = param.success, theme = param.theme;
    return pending ? theme.colors.primary : success ? theme.colors.success : theme.colors.failure;
});
function Transaction(param) {
    var tx = param.tx;
    var ref, ref1;
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var summary = tx === null || tx === void 0 ? void 0 : tx.summary;
    var pending = !(tx === null || tx === void 0 ? void 0 : tx.receipt);
    var success = !pending && tx && (((ref = tx.receipt) === null || ref === void 0 ? void 0 : ref.status) === 1 || typeof ((ref1 = tx.receipt) === null || ref1 === void 0 ? void 0 : ref1.status) === "undefined");
    if (!chainId) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TransactionState, {
        pending: pending,
        success: success,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* default */.Z, {
                href: (0,utils/* getBscScanLink */.s6)(tx.hash, "transaction", chainId),
                children: summary !== null && summary !== void 0 ? summary : tx.hash
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                pending: pending,
                success: success,
                children: pending ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleLoader/* default */.Z, {}) : success ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkmark/* default */.Z, {
                    color: "success"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                    color: "failure"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(30621);
;// CONCATENATED MODULE: ./src/components/App/Transactions/TransactionsModal.tsx












function renderTransactions(transactions) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        flexDirection: "column",
        children: transactions.map(function(tx) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Transaction, {
                tx: tx
            }, tx.hash + tx.addedTime);
        })
    });
}
var TransactionsModal = function(param) {
    var onDismiss = param.onDismiss;
    var ref = (0,useActiveWeb3React/* default */.Z)(), account = ref.account, chainId = ref.chainId;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var allTransactions = (0,hooks/* useAllTransactions */.kf)();
    var t = (0,Localization/* useTranslation */.$G)().t;
    var sortedRecentTransactions = orderBy_default()(Object.values(allTransactions).filter(hooks/* isTransactionRecent */.mH), "addedTime", "desc");
    var pending = sortedRecentTransactions.filter(function(tx) {
        return !tx.receipt;
    });
    var confirmed = sortedRecentTransactions.filter(function(tx) {
        return tx.receipt;
    });
    var clearAllTransactionsCallback = (0,react.useCallback)(function() {
        if (chainId) dispatch((0,actions/* clearAllTransactions */.fY)({
            chainId: chainId
        }));
    }, [
        dispatch,
        chainId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        title: t("Recent Transactions"),
        headerBackground: "gradients.cardHeader",
        onDismiss: onDismiss,
        children: account ? /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalBody */.fe, {
            children: !!pending.length || !!confirmed.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* AutoRow */.BA, {
                        mb: "1rem",
                        style: {
                            justifyContent: "space-between"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                children: t("Recent Transactions")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "tertiary",
                                scale: "xs",
                                onClick: clearAllTransactionsCallback,
                                children: t("clear all")
                            })
                        ]
                    }),
                    renderTransactions(pending),
                    renderTransactions(confirmed)
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: t("No recent transactions")
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {})
    });
};
/* harmony default export */ var Transactions_TransactionsModal = (TransactionsModal);


/***/ }),

/***/ 45460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j": function() { return /* reexport */ AppBody; },
  "t": function() { return /* reexport */ App_AppHeader; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(5527);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowBack.tsx
var ArrowBack = __webpack_require__(69508);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(59750);
// EXTERNAL MODULE: ./packages/uikit/src/components/NotificationDot/NotificationDot.tsx
var NotificationDot = __webpack_require__(45341);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var hooks = __webpack_require__(68605);
// EXTERNAL MODULE: ./src/components/Menu/GlobalSettings/index.tsx + 4 modules
var GlobalSettings = __webpack_require__(8742);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(65528);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/History.tsx
var History = __webpack_require__(85714);
// EXTERNAL MODULE: ./src/components/App/Transactions/TransactionsModal.tsx + 1 modules
var TransactionsModal = __webpack_require__(86921);
;// CONCATENATED MODULE: ./src/components/App/Transactions/index.tsx




var Transactions = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionsModal/* default */.Z, {})), 1), onPresentTransactionsModal = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
            scale: "sm",
            variant: "text",
            onClick: onPresentTransactionsModal,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(History/* default */.Z, {
                color: "textSubtle",
                width: "24px"
            })
        })
    });
};
/* harmony default export */ var App_Transactions = (Transactions);

// EXTERNAL MODULE: ./src/components/QuestionHelper/index.tsx
var QuestionHelper = __webpack_require__(45061);
// EXTERNAL MODULE: ./src/components/Menu/GlobalSettings/types.ts
var types = __webpack_require__(47431);
;// CONCATENATED MODULE: ./src/components/App/AppHeader.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  justify-content: space-between;\n  padding: 24px;\n  width: 100%;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var AppHeaderContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-83f45a56-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var AppHeader = function(param) {
    var title = param.title, subtitle = param.subtitle, helper = param.helper, backTo = param.backTo, _noConfig = param.noConfig, noConfig = _noConfig === void 0 ? false : _noConfig;
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useExpertModeManager */.DG)(), 1), expertMode = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppHeaderContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            alignItems: "center",
            width: "100%",
            style: {
                gap: "16px"
            },
            children: [
                backTo && (typeof backTo === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    passHref: true,
                    href: backTo,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        as: "a",
                        scale: "sm",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack/* default */.Z, {
                            width: "32px"
                        })
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    scale: "sm",
                    variant: "text",
                    onClick: backTo,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack/* default */.Z, {
                        width: "32px"
                    })
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    flexDirection: "column",
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            mb: "8px",
                            alignItems: "center",
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                    as: "h2",
                                    children: title
                                }),
                                !noConfig && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationDot/* default */.Z, {
                                            show: expertMode,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalSettings/* default */.Z, {
                                                mode: types/* SettingsMode.SWAP_LIQUIDITY */.a.SWAP_LIQUIDITY
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(App_Transactions, {})
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            alignItems: "center",
                            children: [
                                helper && /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* default */.Z, {
                                    text: helper,
                                    mr: "4px",
                                    placement: "top-start"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: "textSubtle",
                                    fontSize: "14px",
                                    children: subtitle
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var App_AppHeader = (AppHeader);

// EXTERNAL MODULE: ./packages/uikit/src/components/Card/Card.tsx + 1 modules
var Card = __webpack_require__(38144);
;// CONCATENATED MODULE: ./src/components/App/AppBody.tsx

function AppBody_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 12px;\n  max-width: 436px;\n  width: 100%;\n  z-index: 1;\n"
    ]);
    AppBody_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var BodyWrapper = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-17495024-0"
})(AppBody_templateObject());
/**
 * The styled container element that wraps the content of most pages and the tabs.
 */ function AppBody(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyWrapper, {
        children: children
    });
};

;// CONCATENATED MODULE: ./src/components/App/index.tsx




/***/ }),

/***/ 36261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h2": function() { return /* binding */ GreyCard; },
/* harmony export */   "hl": function() { return /* binding */ LightCard; },
/* harmony export */   "m5": function() { return /* binding */ LightGreyCard; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87379);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7180);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  padding: ",
        ";\n  border: ",
        ";\n  border-radius: ",
        ";\n  background-color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var Card = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-95a24a72-0"
})(_templateObject(), function(param) {
    var width = param.width;
    return width !== null && width !== void 0 ? width : "100%";
}, function(param) {
    var padding = param.padding;
    return padding !== null && padding !== void 0 ? padding : "1.25rem";
}, function(param) {
    var border = param.border;
    return border;
}, function(param) {
    var borderRadius = param.borderRadius;
    return borderRadius !== null && borderRadius !== void 0 ? borderRadius : "12px";
}, function(param) {
    var theme = param.theme;
    return theme.colors.background;
});
/* harmony default export */ __webpack_exports__["ZP"] = (Card);
var LightCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Card).withConfig({
    componentId: "sc-95a24a72-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
});
var LightGreyCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Card).withConfig({
    componentId: "sc-95a24a72-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.colors.background;
});
var GreyCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Card).withConfig({
    componentId: "sc-95a24a72-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.dropdown;
});


/***/ }),

/***/ 41914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tz": function() { return /* binding */ AutoColumn; },
/* harmony export */   "lg": function() { return /* binding */ ColumnCenter; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87379);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n  grid-auto-rows: auto;\n  grid-row-gap: ",
        ";\n  justify-items: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var Column = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-91e5cc43-0"
})(_templateObject());
var ColumnCenter = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Column).withConfig({
    componentId: "sc-91e5cc43-1"
})(_templateObject1());
var AutoColumn = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-91e5cc43-2"
})(_templateObject2(), function(param) {
    var gap = param.gap;
    return gap === "sm" && "8px" || gap === "md" && "12px" || gap === "lg" && "24px" || gap;
}, function(param) {
    var justify = param.justify;
    return justify;
});
/* harmony default export */ __webpack_exports__["ZP"] = (Column);


/***/ }),

/***/ 39475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BA": function() { return /* binding */ AutoRow; },
/* harmony export */   "DA": function() { return /* binding */ RowFixed; },
/* harmony export */   "m0": function() { return /* binding */ RowBetween; }
/* harmony export */ });
/* unused harmony export RowFlat */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87379);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7180);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  display: flex;\n  align-items: ",
        ";\n  justify-content: ",
        ";\n  padding: ",
        ";\n  border: ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  justify-content: space-between;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: flex-end;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-wrap: wrap;\n  margin: ",
        ";\n  justify-content: ",
        ";\n\n  & > * {\n    margin: ",
        " !important;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: fit-content;\n  margin: ",
        ";\n\n  & > * {\n    margin: ",
        " !important;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var Row = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-a99b64d2-0"
})(_templateObject(), function(param) {
    var width = param.width;
    return width !== null && width !== void 0 ? width : "100%";
}, function(param) {
    var align = param.align;
    return align !== null && align !== void 0 ? align : "center";
}, function(param) {
    var justify = param.justify;
    return justify !== null && justify !== void 0 ? justify : "flex-start";
}, function(param) {
    var padding = param.padding;
    return padding !== null && padding !== void 0 ? padding : "0";
}, function(param) {
    var border = param.border;
    return border;
}, function(param) {
    var borderRadius = param.borderRadius;
    return borderRadius;
});
var RowBetween = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Row).withConfig({
    componentId: "sc-a99b64d2-1"
})(_templateObject1());
var RowFlat = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a99b64d2-2"
})(_templateObject2());
var AutoRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Row).withConfig({
    componentId: "sc-a99b64d2-3"
})(_templateObject3(), function(param) {
    var gap = param.gap;
    return gap && "-".concat(gap);
}, function(param) {
    var justify = param.justify;
    return justify;
}, function(param) {
    var gap = param.gap;
    return gap;
});
var RowFixed = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Row).withConfig({
    componentId: "sc-a99b64d2-4"
})(_templateObject4(), function(param) {
    var gap = param.gap;
    return gap && "-".concat(gap);
}, function(param) {
    var gap = param.gap;
    return gap;
});
/* harmony default export */ __webpack_exports__["ZP"] = (Row);


/***/ }),

/***/ 28630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CircleLoader; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  animation: 2s ",
        " linear infinite;\n  height: ",
        ";\n  width: ",
        ";\n  path {\n    stroke: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var rotate = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .keyframes */ .F4)(_templateObject());
var StyledSVG = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].svg.withConfig */ .ZP.svg.withConfig({
    componentId: "sc-fa227f0-0"
})(_templateObject1(), rotate, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var stroke = param.stroke, theme = param.theme;
    return stroke !== null && stroke !== void 0 ? stroke : theme.colors.primary;
});
/**
 * Takes in custom size and stroke for circle color, default to primary color as fill,
 * need ...rest for layered styles on top
 */ function CircleLoader(_param) {
    var _size = _param.size, size = _size === void 0 ? "16px" : _size, stroke = _param.stroke, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "size",
        "stroke"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSVG, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        size: size,
        stroke: stroke
    }, rest), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
            d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 9.27455 20.9097 6.80375 19.1414 5",
            strokeWidth: "2.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }));
};


/***/ }),

/***/ 292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CurrencyLogo; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 32 modules
var src = __webpack_require__(54346);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Binance.tsx
var Binance = __webpack_require__(5724);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/state/types.ts
var types = __webpack_require__(45101);
// EXTERNAL MODULE: ./src/hooks/useHttpLocations.ts
var useHttpLocations = __webpack_require__(74753);
;// CONCATENATED MODULE: ./src/utils/getTokenLogoURL.ts
var getTokenLogoURL = function(address) {
    return "/images/tokens/".concat(address, ".png");
};
/* harmony default export */ var utils_getTokenLogoURL = (getTokenLogoURL);

// EXTERNAL MODULE: ./src/components/Logo/Logo.tsx
var Logo = __webpack_require__(79350);
;// CONCATENATED MODULE: ./src/components/Logo/CurrencyLogo.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  border-radius: 50%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var StyledLogo = (0,styled_components_browser_esm/* default */.ZP)(Logo/* default */.Z).withConfig({
    componentId: "sc-22b0add6-0"
})(_templateObject(), function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
});
function CurrencyLogo(param) {
    var currency = param.currency, _size = param.size, size = _size === void 0 ? "24px" : _size, style = param.style;
    var uriLocations = (0,useHttpLocations/* default */.Z)((0,_instanceof/* default */.Z)(currency, types/* WrappedTokenInfo */.DT) ? currency.logoURI : undefined);
    var srcs = (0,react.useMemo)(function() {
        if (currency === src/* ETHER */.c0) return [];
        if ((0,_instanceof/* default */.Z)(currency, src/* Token */.WU)) {
            if ((0,_instanceof/* default */.Z)(currency, types/* WrappedTokenInfo */.DT)) {
                return (0,_to_consumable_array/* default */.Z)(uriLocations).concat([
                    utils_getTokenLogoURL(currency.address)
                ]);
            }
            return [
                utils_getTokenLogoURL(currency.address)
            ];
        }
        return [];
    }, [
        currency,
        uriLocations
    ]);
    if (currency === src/* ETHER */.c0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Binance/* default */.Z, {
            width: size,
            style: style
        });
    }
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLogo, {
        size: size,
        srcs: srcs,
        alt: "".concat((ref = currency === null || currency === void 0 ? void 0 : currency.symbol) !== null && ref !== void 0 ? ref : "token", " logo"),
        style: style
    });
};


/***/ }),

/***/ 74314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Xw": function() { return /* reexport */ CurrencyLogo/* default */.Z; },
  "ge": function() { return /* reexport */ DoubleCurrencyLogo; },
  "_r": function() { return /* reexport */ ListLogo; }
});

// EXTERNAL MODULE: ./src/components/Logo/CurrencyLogo.tsx + 1 modules
var CurrencyLogo = __webpack_require__(292);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./src/components/Logo/DoubleLogo.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  margin-right: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b339c6de-0"
})(_templateObject(), function(param) {
    var margin = param.margin;
    return margin && "4px";
});
function DoubleCurrencyLogo(param) {
    var currency0 = param.currency0, currency1 = param.currency1, _size = param.size, size = _size === void 0 ? 20 : _size, _margin = param.margin, margin = _margin === void 0 ? false : _margin;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        margin: margin,
        children: [
            currency0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo/* default */.Z, {
                currency: currency0,
                size: "".concat(size.toString(), "px"),
                style: {
                    marginRight: "4px"
                }
            }),
            currency1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo/* default */.Z, {
                currency: currency1,
                size: "".concat(size.toString(), "px")
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/hooks/useHttpLocations.ts
var useHttpLocations = __webpack_require__(74753);
// EXTERNAL MODULE: ./src/components/Logo/Logo.tsx
var Logo = __webpack_require__(79350);
;// CONCATENATED MODULE: ./src/components/Logo/ListLogo.tsx

function ListLogo_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n"
    ]);
    ListLogo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledListLogo = (0,styled_components_browser_esm/* default */.ZP)(Logo/* default */.Z).withConfig({
    componentId: "sc-60793395-0"
})(ListLogo_templateObject(), function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
});
function ListLogo(param) {
    var logoURI = param.logoURI, style = param.style, _size = param.size, size = _size === void 0 ? "24px" : _size, alt = param.alt;
    var srcs = (0,useHttpLocations/* default */.Z)(logoURI);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledListLogo, {
        alt: alt,
        size: size,
        srcs: srcs,
        style: style
    });
};

;// CONCATENATED MODULE: ./src/components/Logo/index.ts





/***/ }),

/***/ 8742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Menu_GlobalSettings; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(65528);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(5527);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Cog.tsx
var Cog = __webpack_require__(86770);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/Modal.tsx
var Modal = __webpack_require__(90452);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/components/Toggle/Toggle.tsx + 2 modules
var Toggle = __webpack_require__(20508);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var hooks = __webpack_require__(68605);
// EXTERNAL MODULE: ./src/state/swap/useSwapActionHandlers.ts
var useSwapActionHandlers = __webpack_require__(95271);
// EXTERNAL MODULE: ./src/contexts/Localization/index.tsx + 3 modules
var Localization = __webpack_require__(99150);
// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(23917);
// EXTERNAL MODULE: ./src/components/QuestionHelper/index.tsx
var QuestionHelper = __webpack_require__(45061);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(93293);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(96293);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx + 29 modules
var Box = __webpack_require__(7180);
// EXTERNAL MODULE: ./packages/uikit/src/components/Input/Input.tsx
var Input = __webpack_require__(5324);
;// CONCATENATED MODULE: ./src/components/Menu/GlobalSettings/TransactionSettings.tsx








var SlippageError;
(function(SlippageError) {
    SlippageError["InvalidInput"] = "InvalidInput";
    SlippageError["RiskyLow"] = "RiskyLow";
    SlippageError["RiskyHigh"] = "RiskyHigh";
})(SlippageError || (SlippageError = {}));
var DeadlineError;
(function(DeadlineError) {
    DeadlineError["InvalidInput"] = "InvalidInput";
})(DeadlineError || (DeadlineError = {}));
var inputRegex = RegExp("^\\d*(?:\\\\[.])?\\d*$") // match escaped "." characters via in a non-capturing group
;
var THREE_DAYS_IN_SECONDS = 60 * 60 * 24 * 3;
var SlippageTabs = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useUserSlippageTolerance */.$2)(), 2), userSlippageTolerance = ref[0], setUserSlippageTolerance = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useUserTransactionTTL */.A6)(), 2), ttl = ref1[0], setTtl = ref1[1];
    var ref2 = (0,react.useState)(""), slippageInput = ref2[0], setSlippageInput = ref2[1];
    var ref3 = (0,react.useState)(""), deadlineInput = ref3[0], setDeadlineInput = ref3[1];
    var t = (0,Localization/* useTranslation */.$G)().t;
    var slippageInputIsValid = slippageInput === "" || (userSlippageTolerance / 100).toFixed(2) === Number.parseFloat(slippageInput).toFixed(2);
    var deadlineInputIsValid = deadlineInput === "" || (ttl / 60).toString() === deadlineInput;
    var slippageError;
    if (slippageInput !== "" && !slippageInputIsValid) {
        slippageError = SlippageError.InvalidInput;
    } else if (slippageInputIsValid && userSlippageTolerance < 50) {
        slippageError = SlippageError.RiskyLow;
    } else if (slippageInputIsValid && userSlippageTolerance > 500) {
        slippageError = SlippageError.RiskyHigh;
    } else {
        slippageError = undefined;
    }
    var deadlineError;
    if (deadlineInput !== "" && !deadlineInputIsValid) {
        deadlineError = DeadlineError.InvalidInput;
    } else {
        deadlineError = undefined;
    }
    var parseCustomSlippage = function(value) {
        if (value === "" || inputRegex.test((0,utils/* escapeRegExp */.hr)(value))) {
            setSlippageInput(value);
            try {
                var valueAsIntFromRoundedFloat = Number.parseInt((Number.parseFloat(value) * 100).toString());
                if (!Number.isNaN(valueAsIntFromRoundedFloat) && valueAsIntFromRoundedFloat < 5000) {
                    setUserSlippageTolerance(valueAsIntFromRoundedFloat);
                }
            } catch (error) {
                console.error(error);
            }
        }
    };
    var parseCustomDeadline = function(value) {
        setDeadlineInput(value);
        try {
            var valueAsInt = Number.parseInt(value) * 60;
            if (!Number.isNaN(valueAsInt) && valueAsInt > 60 && valueAsInt < THREE_DAYS_IN_SECONDS) {
                setTtl(valueAsInt);
            } else {
                deadlineError = DeadlineError.InvalidInput;
            }
        } catch (error) {
            console.error(error);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: "column",
                mb: "24px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        mb: "12px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                children: t("Slippage Tolerance")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* default */.Z, {
                                text: t("Setting a high slippage tolerance can help transactions succeed, but you may not get such a good price. Use with caution."),
                                placement: "top-start",
                                ml: "4px"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexWrap: "wrap",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                mt: "4px",
                                mr: "4px",
                                scale: "sm",
                                onClick: function() {
                                    setSlippageInput("");
                                    setUserSlippageTolerance(10);
                                },
                                variant: userSlippageTolerance === 10 ? "primary" : "tertiary",
                                children: "0.1%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                mt: "4px",
                                mr: "4px",
                                scale: "sm",
                                onClick: function() {
                                    setSlippageInput("");
                                    setUserSlippageTolerance(50);
                                },
                                variant: userSlippageTolerance === 50 ? "primary" : "tertiary",
                                children: "0.5%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                mr: "4px",
                                mt: "4px",
                                scale: "sm",
                                onClick: function() {
                                    setSlippageInput("");
                                    setUserSlippageTolerance(100);
                                },
                                variant: userSlippageTolerance === 100 ? "primary" : "tertiary",
                                children: "1.0%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        width: "76px",
                                        mt: "4px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                            scale: "sm",
                                            inputMode: "decimal",
                                            pattern: "^[0-9]*[.,]?[0-9]{0,2}$",
                                            placeholder: (userSlippageTolerance / 100).toFixed(2),
                                            value: slippageInput,
                                            onBlur: function() {
                                                parseCustomSlippage((userSlippageTolerance / 100).toFixed(2));
                                            },
                                            onChange: function(event) {
                                                if (event.currentTarget.validity.valid) {
                                                    parseCustomSlippage(event.target.value.replace(/,/g, "."));
                                                }
                                            },
                                            isWarning: !slippageInputIsValid,
                                            isSuccess: ![
                                                10,
                                                50,
                                                100
                                            ].includes(userSlippageTolerance)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "primary",
                                        bold: true,
                                        ml: "2px",
                                        children: "%"
                                    })
                                ]
                            })
                        ]
                    }),
                    !!slippageError && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "14px",
                        color: slippageError === SlippageError.InvalidInput ? "red" : "#F3841E",
                        mt: "8px",
                        children: slippageError === SlippageError.InvalidInput ? t("Enter a valid slippage percentage") : slippageError === SlippageError.RiskyLow ? t("Your transaction may fail") : t("Your transaction may be frontrun")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "space-between",
                alignItems: "center",
                mb: "24px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                children: t("Tx deadline (mins)")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* default */.Z, {
                                text: t("Your transaction will revert if it is left confirming for longer than this time."),
                                placement: "top-start",
                                ml: "4px"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            width: "52px",
                            mt: "4px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                scale: "sm",
                                inputMode: "numeric",
                                pattern: "^[0-9]+$",
                                isWarning: !!deadlineError,
                                onBlur: function() {
                                    parseCustomDeadline((ttl / 60).toString());
                                },
                                placeholder: (ttl / 60).toString(),
                                value: deadlineInput,
                                onChange: function(event) {
                                    if (event.currentTarget.validity.valid) {
                                        parseCustomDeadline(event.target.value);
                                    }
                                }
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TransactionSettings = (SlippageTabs);

// EXTERNAL MODULE: ./packages/uikit/src/components/Message/Message.tsx + 1 modules
var Message = __webpack_require__(67334);
// EXTERNAL MODULE: ./packages/uikit/src/components/Checkbox/Checkbox.tsx + 1 modules
var Checkbox = __webpack_require__(19731);
;// CONCATENATED MODULE: ./src/components/Menu/GlobalSettings/ExpertModal.tsx






var ExpertModal = function(param) {
    var setShowConfirmExpertModal = param.setShowConfirmExpertModal, setShowExpertModeAcknowledgement = param.setShowExpertModeAcknowledgement;
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useExpertModeManager */.DG)(), 2), toggleExpertMode = ref[1];
    var ref1 = (0,react.useState)(false), isRememberChecked = ref1[0], setIsRememberChecked = ref1[1];
    var t = (0,Localization/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        title: t("Expert Mode"),
        onBack: function() {
            return setShowConfirmExpertModal(false);
        },
        onDismiss: function() {
            return setShowConfirmExpertModal(false);
        },
        headerBackground: "gradients.cardHeader",
        style: {
            maxWidth: "360px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                variant: "warning",
                mb: "24px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    children: t("Expert mode turns off the 'Confirm' transaction prompt, and allows high slippage trades that often result in bad rates and lost funds.")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                mb: "24px",
                children: t("Only use this mode if you know what you\u2019re doing.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                mb: "24px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        name: "confirmed",
                        type: "checkbox",
                        checked: isRememberChecked,
                        onChange: function() {
                            return setIsRememberChecked(!isRememberChecked);
                        },
                        scale: "sm"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        ml: "10px",
                        color: "textSubtle",
                        style: {
                            userSelect: "none"
                        },
                        children: t("Don\u2019t show this again")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                mb: "8px",
                id: "confirm-expert-mode",
                onClick: function() {
                    // eslint-disable-next-line no-alert
                    if (window.prompt('Please type the word "confirm" to enable expert mode.') === "confirm") {
                        toggleExpertMode();
                        setShowConfirmExpertModal(false);
                        if (isRememberChecked) {
                            setShowExpertModeAcknowledgement(false);
                        }
                    }
                },
                children: t("Turn On Expert Mode")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                variant: "secondary",
                onClick: function() {
                    setShowConfirmExpertModal(false);
                },
                children: t("Cancel")
            })
        ]
    });
};
/* harmony default export */ var GlobalSettings_ExpertModal = (ExpertModal);

// EXTERNAL MODULE: ./src/state/types.ts
var types = __webpack_require__(45101);
;// CONCATENATED MODULE: ./src/components/Menu/GlobalSettings/GasSettings.tsx







var GasSettings = function() {
    var t = (0,Localization/* useTranslation */.$G)().t;
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useGasPriceManager */.nF)(), 2), gasPrice = ref[0], setGasPrice = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                mb: "12px",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: t("Default Transaction Speed (GWEI)")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* default */.Z, {
                        text: t("Adjusts the gas price (transaction fee) for your transaction. Higher GWEI = higher speed = higher fees"),
                        placement: "top-start",
                        ml: "4px"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexWrap: "wrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        mt: "4px",
                        mr: "4px",
                        scale: "sm",
                        onClick: function() {
                            setGasPrice(types/* GAS_PRICE_GWEI.default */.j4["default"]);
                        },
                        variant: gasPrice === types/* GAS_PRICE_GWEI.default */.j4["default"] ? "primary" : "tertiary",
                        children: t("Standard (%gasPrice%)", {
                            gasPrice: types/* GAS_PRICE.default */.DB["default"]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        mt: "4px",
                        mr: "4px",
                        scale: "sm",
                        onClick: function() {
                            setGasPrice(types/* GAS_PRICE_GWEI.fast */.j4.fast);
                        },
                        variant: gasPrice === types/* GAS_PRICE_GWEI.fast */.j4.fast ? "primary" : "tertiary",
                        children: t("Fast (%gasPrice%)", {
                            gasPrice: types/* GAS_PRICE.fast */.DB.fast
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        mr: "4px",
                        mt: "4px",
                        scale: "sm",
                        onClick: function() {
                            setGasPrice(types/* GAS_PRICE_GWEI.instant */.j4.instant);
                        },
                        variant: gasPrice === types/* GAS_PRICE_GWEI.instant */.j4.instant ? "primary" : "tertiary",
                        children: t("Instant (%gasPrice%)", {
                            gasPrice: types/* GAS_PRICE.instant */.DB.instant
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var GlobalSettings_GasSettings = (GasSettings);

// EXTERNAL MODULE: ./src/components/Menu/GlobalSettings/types.ts
var GlobalSettings_types = __webpack_require__(47431);
;// CONCATENATED MODULE: ./src/components/Menu/GlobalSettings/SettingsModal.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  ",
        " {\n    max-height: none;\n    height: 90vh;\n  }\n  ",
        " {\n    max-height: none;\n    height: auto;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* eslint-disable @typescript-eslint/no-unused-vars */ 











var ScrollableContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5404d237-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xs;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var SettingsModal = function(param) {
    var onDismiss = param.onDismiss, mode = param.mode;
    var ref = (0,react.useState)(false), showConfirmExpertModal = ref[0], setShowConfirmExpertModal = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useUserExpertModeAcknowledgementShow */.wX)(), 2), showExpertModeAcknowledgement = ref1[0], setShowExpertModeAcknowledgement = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useExpertModeManager */.DG)(), 2), expertMode = ref2[0], toggleExpertMode = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useUserSingleHopOnly */.RO)(), 2), singleHopOnly = ref3[0], setSingleHopOnly = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useAudioModeManager */.TO)(), 2), audioPlay = ref4[0], toggleSetAudioMode = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useZapModeManager */.$f)(), 2), zapMode = ref5[0], toggleZapMode = ref5[1];
    // const [subgraphHealth, setSubgraphHealth] = useSubgraphHealthIndicatorManager()
    var onChangeRecipient = (0,useSwapActionHandlers/* useSwapActionHandlers */._)().onChangeRecipient;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var ref6 = (0,useTheme/* default */.ZP)(), isDark = ref6.isDark, setTheme = ref6.setTheme;
    if (showConfirmExpertModal) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalSettings_ExpertModal, {
            setShowConfirmExpertModal: setShowConfirmExpertModal,
            onDismiss: onDismiss,
            setShowExpertModeAcknowledgement: setShowExpertModeAcknowledgement
        });
    }
    var handleExpertModeToggle = function() {
        if (expertMode) {
            onChangeRecipient(null);
            toggleExpertMode();
        } else if (!showExpertModeAcknowledgement) {
            onChangeRecipient(null);
            toggleExpertMode();
        } else {
            setShowConfirmExpertModal(true);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        title: t("Settings"),
        headerBackground: "gradients.cardHeader",
        onDismiss: onDismiss,
        style: {
            maxWidth: "420px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScrollableContainer, {
            children: [
                mode === GlobalSettings_types/* SettingsMode.GLOBAL */.a.GLOBAL && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        pb: "24px",
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                bold: true,
                                textTransform: "uppercase",
                                fontSize: "18px",
                                color: "secondary",
                                mb: "24px",
                                children: t("Global")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalSettings_GasSettings, {})
                        ]
                    })
                }),
                mode === GlobalSettings_types/* SettingsMode.SWAP_LIQUIDITY */.a.SWAP_LIQUIDITY && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            pt: "3px",
                            flexDirection: "column",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionSettings, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            justifyContent: "space-between",
                            alignItems: "center",
                            mb: "24px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            children: t("Expert Mode")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* default */.Z, {
                                            text: t("Bypasses confirmation modals and allows high slippage trades. Use at your own risk."),
                                            placement: "top-start",
                                            ml: "4px"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Toggle/* default */.Z, {
                                    id: "toggle-expert-mode-button",
                                    scale: "md",
                                    checked: expertMode,
                                    onChange: handleExpertModeToggle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            justifyContent: "space-between",
                            alignItems: "center",
                            mb: "24px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            children: t("Disable Multihops")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* default */.Z, {
                                            text: t("Restricts swaps to direct pairs only."),
                                            placement: "top-start",
                                            ml: "4px"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Toggle/* default */.Z, {
                                    id: "toggle-disable-multihop-button",
                                    checked: singleHopOnly,
                                    scale: "md",
                                    onChange: function() {
                                        setSingleHopOnly(!singleHopOnly);
                                    }
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var GlobalSettings_SettingsModal = (SettingsModal);

;// CONCATENATED MODULE: ./src/components/Menu/GlobalSettings/index.tsx




var GlobalSettings = function(param) {
    var color = param.color, _mr = param.mr, mr = _mr === void 0 ? "8px" : _mr, mode = param.mode;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalSettings_SettingsModal, {
        mode: mode
    })), 1), onPresentSettingsModal = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
            onClick: onPresentSettingsModal,
            variant: "text",
            scale: "sm",
            mr: mr,
            id: "open-settings-dialog-button-".concat(mode),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cog/* default */.Z, {
                height: 24,
                width: 24,
                color: color || "textSubtle"
            })
        })
    });
};
/* harmony default export */ var Menu_GlobalSettings = (GlobalSettings);


/***/ }),

/***/ 47431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ SettingsMode; }
/* harmony export */ });
var SettingsMode;
(function(SettingsMode) {
    SettingsMode["GLOBAL"] = "GLOBAL";
    SettingsMode["SWAP_LIQUIDITY"] = "SWAP_LIQUIDITY";
})(SettingsMode || (SettingsMode = {}));


/***/ }),

/***/ 45061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36544);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7180);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62276);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  :hover,\n  :focus {\n    opacity: 0.7;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var QuestionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-45c23154-0"
})(_templateObject());
var QuestionHelper = function(_param) {
    var text = _param.text, _placement = _param.placement, placement = _placement === void 0 ? "right-end" : _placement, _size = _param.size, size = _size === void 0 ? "16px" : _size, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text",
        "placement",
        "size"
    ]);
    var ref = (0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(text, {
        placement: placement
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(QuestionWrapper, {
                ref: targetRef,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    color: "textSubtle",
                    width: size
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (QuestionHelper);


/***/ }),

/***/ 74753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useHttpLocations; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var utils_uriToHttp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90570);


function useHttpLocations(uri) {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return uri ? (0,utils_uriToHttp__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(uri) : [];
    }, [
        uri
    ]);
};


/***/ }),

/***/ 81081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jj": function() { return /* binding */ useDefaultsFromURLSearch; },
  "SM": function() { return /* binding */ useDerivedSwapInfo; },
  "rH": function() { return /* binding */ useFetchPairPrices; },
  "aT": function() { return /* binding */ useLPApr; },
  "yF": function() { return /* binding */ useSingleTokenSwapInfo; },
  "dU": function() { return /* binding */ useSwapState; }
});

// UNUSED EXPORTS: queryParametersToSwapState

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 32 modules
var src = __webpack_require__(54346);
// EXTERNAL MODULE: ./node_modules/@web3-react/core/dist/core.esm.js
var core_esm = __webpack_require__(77044);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/config/constants/index.ts
var constants = __webpack_require__(3862);
// EXTERNAL MODULE: ./src/config/constants/exchange.ts
var exchange = __webpack_require__(19838);
// EXTERNAL MODULE: ./node_modules/swr/immutable/dist/index.mjs
var dist = __webpack_require__(49770);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(64011);
// EXTERNAL MODULE: ./src/hooks/Trades.ts + 1 modules
var Trades = __webpack_require__(23715);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/contexts/Localization/index.tsx + 3 modules
var Localization = __webpack_require__(99150);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(93293);
// EXTERNAL MODULE: ./src/utils/getDeltaTimestamps.ts
var getDeltaTimestamps = __webpack_require__(79900);
// EXTERNAL MODULE: ./src/utils/getBlocksFromTimestamps.ts
var getBlocksFromTimestamps = __webpack_require__(12937);
// EXTERNAL MODULE: ./src/utils/getChangeForPeriod.ts
var getChangeForPeriod = __webpack_require__(19683);
// EXTERNAL MODULE: ./src/utils/getLpFeesAndApr.ts
var getLpFeesAndApr = __webpack_require__(2385);
// EXTERNAL MODULE: ./src/utils/exchange.ts + 1 modules
var utils_exchange = __webpack_require__(60872);
// EXTERNAL MODULE: ./src/utils/getLpAddress.ts
var getLpAddress = __webpack_require__(32323);
// EXTERNAL MODULE: ./src/views/Swap/components/Chart/utils.ts
var Chart_utils = __webpack_require__(69197);
// EXTERNAL MODULE: ./src/utils/tryParseAmount.ts
var tryParseAmount = __webpack_require__(97938);
// EXTERNAL MODULE: ./src/state/index.ts + 19 modules
var state = __webpack_require__(31318);
// EXTERNAL MODULE: ./src/state/wallet/hooks.ts
var hooks = __webpack_require__(71900);
// EXTERNAL MODULE: ./src/state/swap/actions.ts
var actions = __webpack_require__(70193);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var user_hooks = __webpack_require__(68605);
// EXTERNAL MODULE: ./src/utils/requestWithTimeout.ts
var requestWithTimeout = __webpack_require__(261);
// EXTERNAL MODULE: ./src/utils/graphql.ts
var graphql = __webpack_require__(75509);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-request/dist/index.js
var graphql_request_dist = __webpack_require__(28687);
;// CONCATENATED MODULE: ./src/state/swap/queries/lastPairDayId.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query lastPairDayId($pairId: String) {\n    pairDayDatas(first: 1, where: { pairAddress: $pairId }, orderBy: date, orderDirection: desc) {\n      id\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var lastPairDayId = (0,graphql_request_dist.gql)(_templateObject());
/* harmony default export */ var queries_lastPairDayId = (lastPairDayId);

;// CONCATENATED MODULE: ./src/state/swap/queries/pairHourDatas.ts

function pairHourDatas_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query pairHourDatas($pairId: String, $first: Int) {\n    pairHourDatas(first: $first, where: { pair: $pairId }, orderBy: hourStartUnix, orderDirection: desc) {\n      id\n      hourStartUnix\n      reserve0\n      reserve1\n      reserveUSD\n      pair {\n        token0 {\n          id\n        }\n        token1 {\n          id\n        }\n      }\n    }\n  }\n"
    ]);
    pairHourDatas_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var pairHourDatas = (0,graphql_request_dist.gql)(pairHourDatas_templateObject());
/* harmony default export */ var queries_pairHourDatas = (pairHourDatas);

;// CONCATENATED MODULE: ./src/state/swap/queries/pairDayDatasByIdsQuery.ts

function pairDayDatasByIdsQuery_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query pairDayDatasByIdsQuery($pairIds: [String]) {\n    pairDayDatas(where: { id_in: $pairIds }, orderBy: date, orderDirection: desc) {\n      id\n      date\n      reserve0\n      reserve1\n      reserveUSD\n      pairAddress {\n        token0 {\n          id\n        }\n        token1 {\n          id\n        }\n      }\n    }\n  }\n"
    ]);
    pairDayDatasByIdsQuery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var pairDayDatasByIdsQuery = (0,graphql_request_dist.gql)(pairDayDatasByIdsQuery_templateObject());
/* harmony default export */ var queries_pairDayDatasByIdsQuery = (pairDayDatasByIdsQuery);

// EXTERNAL MODULE: ./src/state/swap/types.ts
var types = __webpack_require__(5549);
;// CONCATENATED MODULE: ./src/state/swap/fetch/constants.ts


var _obj;
// Specifies the amount of data points to query for specific time window
var timeWindowIdsCountMapping = (_obj = {}, (0,_define_property/* default */.Z)(_obj, types/* PairDataTimeWindowEnum.DAY */.l.DAY, 24), (0,_define_property/* default */.Z)(_obj, types/* PairDataTimeWindowEnum.WEEK */.l.WEEK, 28), (0,_define_property/* default */.Z)(_obj, types/* PairDataTimeWindowEnum.MONTH */.l.MONTH, 30), (0,_define_property/* default */.Z)(_obj, types/* PairDataTimeWindowEnum.YEAR */.l.YEAR, 24), _obj);
var _obj1;
// How many StreamingFast ids to skip when querying the data
var timeWindowGapMapping = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, types/* PairDataTimeWindowEnum.DAY */.l.DAY, null), (0,_define_property/* default */.Z)(_obj1, types/* PairDataTimeWindowEnum.WEEK */.l.WEEK, 6), (0,_define_property/* default */.Z)(_obj1, types/* PairDataTimeWindowEnum.MONTH */.l.MONTH, 1), (0,_define_property/* default */.Z)(_obj1, types/* PairDataTimeWindowEnum.YEAR */.l.YEAR, 15), _obj1);

// EXTERNAL MODULE: ./node_modules/lodash/times.js
var times = __webpack_require__(98913);
var times_default = /*#__PURE__*/__webpack_require__.n(times);
;// CONCATENATED MODULE: ./src/state/swap/fetch/utils.ts



var getPairSequentialId = function(param) {
    var id = param.id, pairId = param.pairId;
    return id.replace("".concat(pairId, "-"), "");
};
var getIdsByTimeWindow = function(param) {
    var pairAddress = param.pairAddress, pairLastId = param.pairLastId, timeWindow = param.timeWindow, idsCount = param.idsCount;
    var pairLastIdAsNumber = Number(pairLastId);
    if (timeWindow === types/* PairDataTimeWindowEnum.DAY */.l.DAY) {
        return [];
    }
    return times_default()(idsCount, function(value) {
        return "".concat(pairAddress, "-").concat(pairLastIdAsNumber - value * timeWindowGapMapping[timeWindow]);
    });
};
var pairHasEnoughLiquidity = function(data, timeWindow) {
    var liquidityThreshold = 10000;
    switch(timeWindow){
        case types/* PairDataTimeWindowEnum.DAY */.l.DAY:
        case types/* PairDataTimeWindowEnum.WEEK */.l.WEEK:
            {
                var ref, ref1, ref2, ref3;
                var ref4;
                var amountOfDataPoints = (ref4 = (ref = data) === null || ref === void 0 ? void 0 : (ref1 = ref.pairHourDatas) === null || ref1 === void 0 ? void 0 : ref1.length) !== null && ref4 !== void 0 ? ref4 : 1;
                var totalUSD = (ref2 = data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.pairHourDatas) === null || ref3 === void 0 ? void 0 : ref3.reduce(function(totalLiquidity, fetchPairEntry) {
                    return totalLiquidity + parseFloat(fetchPairEntry.reserveUSD);
                }, 0);
                return totalUSD / amountOfDataPoints > liquidityThreshold;
            }
        case types/* PairDataTimeWindowEnum.MONTH */.l.MONTH:
        case types/* PairDataTimeWindowEnum.YEAR */.l.YEAR:
            {
                var ref5, ref6, ref7, ref8;
                var ref9;
                var amountOfDataPoints1 = (ref9 = (ref5 = data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.pairDayDatas) === null || ref6 === void 0 ? void 0 : ref6.length) !== null && ref9 !== void 0 ? ref9 : 1;
                var totalUSD1 = (ref7 = data) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.pairDayDatas) === null || ref8 === void 0 ? void 0 : ref8.reduce(function(totalLiquidity, fetchPairEntry) {
                    return totalLiquidity + parseFloat(fetchPairEntry.reserveUSD);
                }, 0);
                return totalUSD1 / amountOfDataPoints1 > liquidityThreshold;
            }
        default:
            return null;
    }
};

;// CONCATENATED MODULE: ./src/state/swap/queries/pairDayDatas.ts

function pairDayDatas_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query pairDayDatas($pairId: String, $first: Int) {\n    pairDayDatas(first: $first, where: { pairAddress: $pairId }, orderBy: date, orderDirection: desc) {\n      id\n      date\n      reserve0\n      reserve1\n      reserveUSD\n      pairAddress {\n        token0 {\n          id\n        }\n        token1 {\n          id\n        }\n      }\n    }\n  }\n"
    ]);
    pairDayDatas_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var pairDayDatas = (0,graphql_request_dist.gql)(pairDayDatas_templateObject());
/* harmony default export */ var queries_pairDayDatas = (pairDayDatas);

;// CONCATENATED MODULE: ./src/state/swap/queries/pairHourDatasByIds.ts

function pairHourDatasByIds_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query pairHourDatasByIds($pairIds: [String]) {\n    pairHourDatas(where: { id_in: $pairIds }, orderBy: hourStartUnix, orderDirection: desc) {\n      id\n      hourStartUnix\n      reserve0\n      reserve1\n      reserveUSD\n      pair {\n        token0 {\n          id\n        }\n        token1 {\n          id\n        }\n      }\n    }\n  }\n"
    ]);
    pairHourDatasByIds_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var pairHourDatasByIds = (0,graphql_request_dist.gql)(pairHourDatasByIds_templateObject());
/* harmony default export */ var queries_pairHourDatasByIds = (pairHourDatasByIds);

;// CONCATENATED MODULE: ./src/state/swap/queries/lastPairHourId.ts

function lastPairHourId_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query lastPairHourId($pairId: String) {\n    pairHourDatas(first: 1, where: { pair: $pairId }, orderBy: hourStartUnix, orderDirection: desc) {\n      id\n    }\n  }\n"
    ]);
    lastPairHourId_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var lastPairHourId = (0,graphql_request_dist.gql)(lastPairHourId_templateObject());
/* harmony default export */ var queries_lastPairHourId = (lastPairHourId);

;// CONCATENATED MODULE: ./src/state/swap/fetch/fetchPairPriceData.ts













var fetchPairPriceData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
        var pairId, timeWindow, client, data, ref, lastPairHourIdData, lastId, pairHourId, pairHourIds, pairHoursData, data1, ref1, lastPairDayIdData, lastId1, pairLastId, pairDayIds, pairDayData;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    pairId = param.pairId, timeWindow = param.timeWindow;
                    client = graphql/* infoClient */.dQ;
                    _ctx.prev = 2;
                    _ctx.t0 = timeWindow;
                    _ctx.next = _ctx.t0 === types/* PairDataTimeWindowEnum.DAY */.l.DAY ? 6 : _ctx.t0 === types/* PairDataTimeWindowEnum.WEEK */.l.WEEK ? 10 : _ctx.t0 === types/* PairDataTimeWindowEnum.MONTH */.l.MONTH ? 23 : _ctx.t0 === types/* PairDataTimeWindowEnum.YEAR */.l.YEAR ? 27 : 40;
                    break;
                case 6:
                    _ctx.next = 8;
                    return (0,requestWithTimeout/* default */.Z)(client, queries_pairHourDatas, {
                        pairId: pairId,
                        first: timeWindowIdsCountMapping[timeWindow]
                    });
                case 8:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", {
                        data: data,
                        error: false
                    });
                case 10:
                    ;
                    _ctx.next = 13;
                    return (0,requestWithTimeout/* default */.Z)(client, queries_lastPairHourId, {
                        pairId: pairId
                    });
                case 13:
                    lastPairHourIdData = _ctx.sent;
                    lastId = (lastPairHourIdData === null || lastPairHourIdData === void 0 ? void 0 : lastPairHourIdData.pairHourDatas) ? (ref = lastPairHourIdData.pairHourDatas[0]) === null || ref === void 0 ? void 0 : ref.id : null;
                    if (lastId) {
                        _ctx.next = 17;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        data: {
                            pairHourDatas: []
                        },
                        error: false
                    });
                case 17:
                    pairHourId = getPairSequentialId({
                        id: lastId,
                        pairId: pairId
                    });
                    pairHourIds = getIdsByTimeWindow({
                        pairAddress: pairId,
                        pairLastId: pairHourId,
                        timeWindow: timeWindow,
                        idsCount: timeWindowIdsCountMapping[timeWindow]
                    });
                    _ctx.next = 21;
                    return (0,requestWithTimeout/* default */.Z)(client, queries_pairHourDatasByIds, {
                        pairIds: pairHourIds
                    });
                case 21:
                    pairHoursData = _ctx.sent;
                    return _ctx.abrupt("return", {
                        data: pairHoursData,
                        error: false
                    });
                case 23:
                    _ctx.next = 25;
                    return (0,requestWithTimeout/* default */.Z)(client, queries_pairDayDatas, {
                        pairId: pairId,
                        first: timeWindowIdsCountMapping[timeWindow]
                    });
                case 25:
                    data1 = _ctx.sent;
                    return _ctx.abrupt("return", {
                        data: data1,
                        error: false
                    });
                case 27:
                    ;
                    _ctx.next = 30;
                    return (0,requestWithTimeout/* default */.Z)(client, queries_lastPairDayId, {
                        pairId: pairId
                    });
                case 30:
                    lastPairDayIdData = _ctx.sent;
                    lastId1 = (lastPairDayIdData === null || lastPairDayIdData === void 0 ? void 0 : lastPairDayIdData.pairDayDatas) ? (ref1 = lastPairDayIdData.pairDayDatas[0]) === null || ref1 === void 0 ? void 0 : ref1.id : null;
                    if (lastId1) {
                        _ctx.next = 34;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        data: {
                            pairDayDatas: []
                        },
                        error: false
                    });
                case 34:
                    pairLastId = getPairSequentialId({
                        id: lastId1,
                        pairId: pairId
                    });
                    pairDayIds = getIdsByTimeWindow({
                        pairAddress: pairId,
                        pairLastId: pairLastId,
                        timeWindow: timeWindow,
                        idsCount: timeWindowIdsCountMapping[timeWindow]
                    });
                    _ctx.next = 38;
                    return (0,requestWithTimeout/* default */.Z)(client, queries_pairDayDatasByIdsQuery, {
                        pairIds: pairDayIds
                    });
                case 38:
                    pairDayData = _ctx.sent;
                    return _ctx.abrupt("return", {
                        data: pairDayData,
                        error: false
                    });
                case 40:
                    return _ctx.abrupt("return", {
                        data: null,
                        error: false
                    });
                case 41:
                    _ctx.next = 47;
                    break;
                case 43:
                    _ctx.prev = 43;
                    _ctx.t1 = _ctx["catch"](2);
                    console.error("Failed to fetch price chart data", _ctx.t1);
                    return _ctx.abrupt("return", {
                        error: true
                    });
                case 47:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                43
            ]
        ]);
    }));
    return function fetchPairPriceData(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var fetch_fetchPairPriceData = (fetchPairPriceData);

// EXTERNAL MODULE: ./node_modules/date-fns/esm/fromUnixTime/index.js
var fromUnixTime = __webpack_require__(42227);
;// CONCATENATED MODULE: ./src/state/swap/normalizers.ts



var normalizeChartData = function(data, timeWindow) {
    switch(timeWindow){
        case types/* PairDataTimeWindowEnum.DAY */.l.DAY:
        case types/* PairDataTimeWindowEnum.WEEK */.l.WEEK:
            var ref, ref1;
            return (ref = data) === null || ref === void 0 ? void 0 : (ref1 = ref.pairHourDatas) === null || ref1 === void 0 ? void 0 : ref1.map(function(fetchPairEntry) {
                return {
                    time: fetchPairEntry.hourStartUnix,
                    token0Id: fetchPairEntry.pair.token0.id,
                    token1Id: fetchPairEntry.pair.token1.id,
                    reserve0: parseFloat(fetchPairEntry.reserve0),
                    reserve1: parseFloat(fetchPairEntry.reserve1)
                };
            });
        case types/* PairDataTimeWindowEnum.MONTH */.l.MONTH:
        case types/* PairDataTimeWindowEnum.YEAR */.l.YEAR:
            var ref2, ref3;
            return (ref2 = data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.pairDayDatas) === null || ref3 === void 0 ? void 0 : ref3.map(function(fetchPairEntry) {
                return {
                    time: fetchPairEntry.date,
                    token0Id: fetchPairEntry.pairAddress.token0.id,
                    token1Id: fetchPairEntry.pairAddress.token1.id,
                    reserve0: parseFloat(fetchPairEntry.reserve0),
                    reserve1: parseFloat(fetchPairEntry.reserve1)
                };
            });
        default:
            return null;
    }
};
var normalizeDerivedChartData = function(data) {
    if (!(data === null || data === void 0 ? void 0 : data.token0DerivedBnb) || (data === null || data === void 0 ? void 0 : data.token0DerivedBnb.length) === 0) {
        return [];
    }
    return data === null || data === void 0 ? void 0 : data.token0DerivedBnb.reduce(function(acc, token0DerivedBnbEntry) {
        var ref;
        var token1DerivedBnbEntry = data === null || data === void 0 ? void 0 : (ref = data.token1DerivedBnb) === null || ref === void 0 ? void 0 : ref.find(function(entry) {
            return entry.timestamp === token0DerivedBnbEntry.timestamp;
        });
        if (!token1DerivedBnbEntry) {
            return acc;
        }
        return (0,_to_consumable_array/* default */.Z)(acc).concat([
            {
                time: parseInt(token0DerivedBnbEntry.timestamp, 10),
                token0Id: token0DerivedBnbEntry.tokenAddress,
                token1Id: token1DerivedBnbEntry.tokenAddress,
                token0DerivedBNB: token0DerivedBnbEntry.derivedBNB,
                token1DerivedBNB: token1DerivedBnbEntry.derivedBNB
            }, 
        ]);
    }, []);
};
var normalizePairDataByActiveToken = function(param) {
    var pairData = param.pairData, activeToken = param.activeToken;
    return pairData === null || pairData === void 0 ? void 0 : pairData.map(function(pairPrice) {
        return {
            time: (0,fromUnixTime/* default */.Z)(pairPrice.time),
            value: activeToken === (pairPrice === null || pairPrice === void 0 ? void 0 : pairPrice.token0Id) ? pairPrice.reserve1 / pairPrice.reserve0 : pairPrice.reserve0 / pairPrice.reserve1
        };
    }).reverse();
};
var normalizeDerivedPairDataByActiveToken = function(param) {
    var pairData = param.pairData, activeToken = param.activeToken;
    return pairData === null || pairData === void 0 ? void 0 : pairData.map(function(pairPrice) {
        return {
            time: (0,fromUnixTime/* default */.Z)(pairPrice.time),
            value: activeToken === (pairPrice === null || pairPrice === void 0 ? void 0 : pairPrice.token0Id) ? pairPrice.token0DerivedBNB / pairPrice.token1DerivedBNB : pairPrice.token1DerivedBNB / pairPrice.token0DerivedBNB
        };
    });
};

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
;// CONCATENATED MODULE: ./src/state/swap/selectors.ts

var pairByDataIdSelector = function(param) {
    var pairId = param.pairId, timeWindow = param.timeWindow;
    return function(state) {
        return get_default()(state, [
            "swap",
            "pairDataById",
            pairId,
            timeWindow
        ]);
    };
};
var derivedPairByDataIdSelector = function(param) {
    var pairId = param.pairId, timeWindow = param.timeWindow;
    return function(state) {
        return get_default()(state, [
            "swap",
            "derivedPairDataById",
            pairId,
            timeWindow
        ]);
    };
};

// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(75472);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
// EXTERNAL MODULE: ./src/config/constants/endpoints.ts
var endpoints = __webpack_require__(85906);
// EXTERNAL MODULE: ./src/config/constants/info.ts
var info = __webpack_require__(4003);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/getUnixTime/index.js
var getUnixTime = __webpack_require__(99982);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfHour/index.js
var startOfHour = __webpack_require__(12383);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/sub/index.js
var sub = __webpack_require__(30734);
// EXTERNAL MODULE: ./src/views/Info/utils/infoQueryHelpers.ts
var infoQueryHelpers = __webpack_require__(75126);
;// CONCATENATED MODULE: ./src/state/swap/queries/getDerivedPrices.ts

function getDerivedPrices_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query derivedTokenPriceData {\n        ",
        "\n      }\n    "
    ]);
    getDerivedPrices_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var getDerivedPrices = function(tokenAddress, blocks) {
    return blocks.map(function(block) {
        return "\n    t".concat(block.timestamp, ':token(id:"').concat(tokenAddress, '", block: { number: ').concat(block.number, " }) { \n        derivedBNB\n      }\n    ");
    });
};
var getDerivedPricesQueryConstructor = function(subqueries) {
    return (0,graphql_request_dist.gql)(getDerivedPrices_templateObject(), subqueries);
};

;// CONCATENATED MODULE: ./src/state/swap/fetch/fetchDerivedPriceData.ts











var getTokenDerivedBnbPrices = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(tokenAddress, blocks) {
        var prices, tokenPrices;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,infoQueryHelpers/* multiQuery */.L)(getDerivedPricesQueryConstructor, getDerivedPrices(tokenAddress, blocks), endpoints/* INFO_CLIENT */.JY, 200);
                case 2:
                    prices = _ctx.sent;
                    if (prices) {
                        _ctx.next = 6;
                        break;
                    }
                    console.error("Price data failed to load");
                    return _ctx.abrupt("return", null);
                case 6:
                    tokenPrices = [];
                    // Get Token prices in PLS
                    Object.keys(prices).forEach(function(priceKey) {
                        var timestamp = priceKey.split("t")[1];
                        if (timestamp) {
                            var ref;
                            tokenPrices.push({
                                tokenAddress: tokenAddress,
                                timestamp: timestamp,
                                derivedBNB: ((ref = prices[priceKey]) === null || ref === void 0 ? void 0 : ref.derivedBNB) ? parseFloat(prices[priceKey].derivedBNB) : 0
                            });
                        }
                    });
                    return _ctx.abrupt("return", orderBy_default()(tokenPrices, function(tokenPrice) {
                        return parseInt(tokenPrice.timestamp, 10);
                    }));
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getTokenDerivedBnbPrices(tokenAddress, blocks) {
        return _ref.apply(this, arguments);
    };
}();
var getInterval = function(timeWindow) {
    switch(timeWindow){
        case types/* PairDataTimeWindowEnum.DAY */.l.DAY:
            return info/* ONE_HOUR_SECONDS */.Tb;
        case types/* PairDataTimeWindowEnum.WEEK */.l.WEEK:
            return info/* ONE_HOUR_SECONDS */.Tb * 4;
        case types/* PairDataTimeWindowEnum.MONTH */.l.MONTH:
            return info/* ONE_DAY_UNIX */.Bq;
        case types/* PairDataTimeWindowEnum.YEAR */.l.YEAR:
            return info/* ONE_DAY_UNIX */.Bq * 15;
        default:
            return info/* ONE_HOUR_SECONDS */.Tb * 4;
    }
};
var getSkipDaysToStart = function(timeWindow) {
    switch(timeWindow){
        case types/* PairDataTimeWindowEnum.DAY */.l.DAY:
            return 1;
        case types/* PairDataTimeWindowEnum.WEEK */.l.WEEK:
            return 7;
        case types/* PairDataTimeWindowEnum.MONTH */.l.MONTH:
            return 30;
        case types/* PairDataTimeWindowEnum.YEAR */.l.YEAR:
            return 365;
        default:
            return 7;
    }
};
// Fetches derivedBnb values for tokens to calculate derived price
// Used when no direct pool is available
var fetchDerivedPriceData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(token0Address, token1Address, timeWindow) {
        var interval, endTimestamp, startTimestamp, timestamps, time, blocks, ref, token0DerivedBnb, token1DerivedBnb;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    interval = getInterval(timeWindow);
                    endTimestamp = (0,getUnixTime/* default */.Z)(new Date());
                    startTimestamp = (0,getUnixTime/* default */.Z)((0,startOfHour/* default */.Z)((0,sub/* default */.Z)(endTimestamp * 1000, {
                        days: getSkipDaysToStart(timeWindow)
                    })));
                    timestamps = [];
                    time = startTimestamp;
                    while(time <= endTimestamp){
                        timestamps.push(time);
                        time += interval;
                    }
                    _ctx.prev = 6;
                    _ctx.next = 9;
                    return (0,getBlocksFromTimestamps/* getBlocksFromTimestamps */.z)(timestamps, "asc", 500);
                case 9:
                    blocks = _ctx.sent;
                    if (!(!blocks || blocks.length === 0)) {
                        _ctx.next = 13;
                        break;
                    }
                    console.error("Error fetching blocks for timestamps", timestamps);
                    return _ctx.abrupt("return", null);
                case 13:
                    _ctx.t0 = _sliced_to_array/* default */.Z;
                    _ctx.next = 16;
                    return Promise.all([
                        getTokenDerivedBnbPrices(token0Address, blocks),
                        getTokenDerivedBnbPrices(token1Address, blocks), 
                    ]);
                case 16:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 2);
                    token0DerivedBnb = ref[0];
                    token1DerivedBnb = ref[1];
                    return _ctx.abrupt("return", {
                        token0DerivedBnb: token0DerivedBnb,
                        token1DerivedBnb: token1DerivedBnb
                    });
                case 23:
                    _ctx.prev = 23;
                    _ctx.t2 = _ctx["catch"](6);
                    console.error("Failed to fetched derived price data for chart", _ctx.t2);
                    return _ctx.abrupt("return", null);
                case 27:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                6,
                23
            ]
        ]);
    }));
    return function fetchDerivedPriceData(token0Address, token1Address, timeWindow) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var fetch_fetchDerivedPriceData = (fetchDerivedPriceData);

// EXTERNAL MODULE: ./src/state/info/queries/pools/poolData.ts
var pools_poolData = __webpack_require__(71021);
;// CONCATENATED MODULE: ./src/state/swap/hooks.ts



































function useSwapState() {
    return (0,es/* useSelector */.v9)(function(state) {
        return state.swap;
    });
}
var BAD_RECIPIENT_ADDRESSES = [
    "0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f",
    "0xf164fC0Ec4E93095b804a4795bBe1e041497b92a",
    "0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D"
];
/**
 * Returns true if any of the pairs or tokens in a trade have the given checksummed address
 * @param trade to check for the given address
 * @param checksummedAddress address to check in the pairs and tokens
 */ function involvesAddress(trade, checksummedAddress) {
    return trade.route.path.some(function(token) {
        return token.address === checksummedAddress;
    }) || trade.route.pairs.some(function(pair) {
        return pair.liquidityToken.address === checksummedAddress;
    });
}
// Get swap price for single token disregarding slippage and price impact
function useSingleTokenSwapInfo(inputCurrencyId, inputCurrency, outputCurrencyId, outputCurrency) {
    var ref;
    var token0Address = (0,Chart_utils/* getTokenAddress */.D)(inputCurrencyId);
    var token1Address = (0,Chart_utils/* getTokenAddress */.D)(outputCurrencyId);
    var parsedAmount = (0,tryParseAmount/* default */.Z)("1", inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined);
    var bestTradeExactIn = (0,Trades/* useTradeExactIn */.AU)(parsedAmount, outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined);
    if (!inputCurrency || !outputCurrency || !bestTradeExactIn) {
        return null;
    }
    var inputTokenPrice = parseFloat(bestTradeExactIn === null || bestTradeExactIn === void 0 ? void 0 : (ref = bestTradeExactIn.executionPrice) === null || ref === void 0 ? void 0 : ref.toSignificant(6));
    var outputTokenPrice = 1 / inputTokenPrice;
    var _obj;
    return _obj = {}, (0,_define_property/* default */.Z)(_obj, token0Address, inputTokenPrice), (0,_define_property/* default */.Z)(_obj, token1Address, outputTokenPrice), _obj;
}
// from the current swap inputs, compute the best trade and return it.
function useDerivedSwapInfo(independentField, typedValue, inputCurrency, outputCurrency, recipient) {
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var ref;
    var to = (ref = recipient === null ? account : (0,utils/* isAddress */.UJ)(recipient) || null) !== null && ref !== void 0 ? ref : null;
    var relevantTokenBalances = (0,hooks/* useCurrencyBalances */.K5)(account !== null && account !== void 0 ? account : undefined, [
        inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined,
        outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined, 
    ]);
    var isExactIn = independentField === actions/* Field.INPUT */.gN.INPUT;
    var ref1;
    var parsedAmount = (0,tryParseAmount/* default */.Z)(typedValue, (ref1 = isExactIn ? inputCurrency : outputCurrency) !== null && ref1 !== void 0 ? ref1 : undefined);
    var bestTradeExactIn = (0,Trades/* useTradeExactIn */.AU)(isExactIn ? parsedAmount : undefined, outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined);
    var bestTradeExactOut = (0,Trades/* useTradeExactOut */["in"])(inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined, !isExactIn ? parsedAmount : undefined);
    var v2Trade = isExactIn ? bestTradeExactIn : bestTradeExactOut;
    var _obj;
    var currencyBalances = (_obj = {}, (0,_define_property/* default */.Z)(_obj, actions/* Field.INPUT */.gN.INPUT, relevantTokenBalances[0]), (0,_define_property/* default */.Z)(_obj, actions/* Field.OUTPUT */.gN.OUTPUT, relevantTokenBalances[1]), _obj);
    var _obj1;
    var currencies = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, actions/* Field.INPUT */.gN.INPUT, inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined), (0,_define_property/* default */.Z)(_obj1, actions/* Field.OUTPUT */.gN.OUTPUT, outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined), _obj1);
    var inputError;
    if (!account) {
        inputError = t("Connect Wallet");
    }
    if (!parsedAmount) {
        inputError = inputError !== null && inputError !== void 0 ? inputError : t("Enter an amount");
    }
    if (!currencies[actions/* Field.INPUT */.gN.INPUT] || !currencies[actions/* Field.OUTPUT */.gN.OUTPUT]) {
        inputError = inputError !== null && inputError !== void 0 ? inputError : t("Select a token");
    }
    var formattedTo = (0,utils/* isAddress */.UJ)(to);
    if (!to || !formattedTo) {
        inputError = inputError !== null && inputError !== void 0 ? inputError : t("Enter a recipient");
    } else if (BAD_RECIPIENT_ADDRESSES.indexOf(formattedTo) !== -1 || bestTradeExactIn && involvesAddress(bestTradeExactIn, formattedTo) || bestTradeExactOut && involvesAddress(bestTradeExactOut, formattedTo)) {
        inputError = inputError !== null && inputError !== void 0 ? inputError : t("Invalid recipient");
    }
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useUserSlippageTolerance */.$2)(), 1), allowedSlippage = ref2[0];
    var slippageAdjustedAmounts = v2Trade && allowedSlippage && (0,utils_exchange/* computeSlippageAdjustedAmounts */.b5)(v2Trade, allowedSlippage);
    // compare input balance to max input based on version
    var ref3 = [
        currencyBalances[actions/* Field.INPUT */.gN.INPUT],
        slippageAdjustedAmounts ? slippageAdjustedAmounts[actions/* Field.INPUT */.gN.INPUT] : null, 
    ], balanceIn = ref3[0], amountIn = ref3[1];
    if (balanceIn && amountIn && balanceIn.lessThan(amountIn)) {
        inputError = t("Insufficient %symbol% balance", {
            symbol: amountIn.currency.symbol
        });
    }
    return {
        currencies: currencies,
        currencyBalances: currencyBalances,
        parsedAmount: parsedAmount,
        v2Trade: v2Trade !== null && v2Trade !== void 0 ? v2Trade : undefined,
        inputError: inputError
    };
}
function parseCurrencyFromURLParameter(urlParam) {
    if (typeof urlParam === "string") {
        var valid = (0,utils/* isAddress */.UJ)(urlParam);
        if (valid) return valid;
        if (urlParam.toUpperCase() === "PLS") return "PLS";
        if (valid === false) return "PLS";
    }
    return "";
}
function parseTokenAmountURLParameter(urlParam) {
    return typeof urlParam === "string" && !Number.isNaN(parseFloat(urlParam)) ? urlParam : "";
}
function parseIndependentFieldURLParameter(urlParam) {
    return typeof urlParam === "string" && urlParam.toLowerCase() === "output" ? actions/* Field.OUTPUT */.gN.OUTPUT : actions/* Field.INPUT */.gN.INPUT;
}
var ADDRESS_REGEX = /^0x[a-fA-F0-9]{40}$/;
function validatedRecipient(recipient) {
    if (typeof recipient !== "string") return null;
    var address = (0,utils/* isAddress */.UJ)(recipient);
    if (address) return address;
    if (ADDRESS_REGEX.test(recipient)) return recipient;
    return null;
}
function queryParametersToSwapState(parsedQs) {
    var inputCurrency = parseCurrencyFromURLParameter(parsedQs.inputCurrency) || exchange/* DEFAULT_INPUT_CURRENCY */.VN;
    var outputCurrency = parseCurrencyFromURLParameter(parsedQs.outputCurrency) || exchange/* DEFAULT_OUTPUT_CURRENCY */.g$;
    if (inputCurrency === outputCurrency) {
        if (typeof parsedQs.outputCurrency === "string") {
            inputCurrency = "";
        } else {
            outputCurrency = "";
        }
    }
    var recipient = validatedRecipient(parsedQs.recipient);
    var _obj;
    return _obj = {}, (0,_define_property/* default */.Z)(_obj, actions/* Field.INPUT */.gN.INPUT, {
        currencyId: inputCurrency
    }), (0,_define_property/* default */.Z)(_obj, actions/* Field.OUTPUT */.gN.OUTPUT, {
        currencyId: outputCurrency
    }), (0,_define_property/* default */.Z)(_obj, "typedValue", parseTokenAmountURLParameter(parsedQs.exactAmount)), (0,_define_property/* default */.Z)(_obj, "independentField", parseIndependentFieldURLParameter(parsedQs.exactField)), (0,_define_property/* default */.Z)(_obj, "recipient", recipient), (0,_define_property/* default */.Z)(_obj, "pairDataById", {}), (0,_define_property/* default */.Z)(_obj, "derivedPairDataById", {}), _obj;
}
// updates the swap state to use the defaults for a given network
function useDefaultsFromURLSearch() {
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var query = (0,router.useRouter)().query;
    var ref = (0,react.useState)(), result = ref[0], setResult = ref[1];
    (0,react.useEffect)(function() {
        if (!chainId) return;
        var parsed = queryParametersToSwapState(query);
        dispatch((0,actions/* replaceSwapState */.mV)({
            typedValue: parsed.typedValue,
            field: parsed.independentField,
            inputCurrencyId: parsed[actions/* Field.INPUT */.gN.INPUT].currencyId,
            outputCurrencyId: parsed[actions/* Field.OUTPUT */.gN.OUTPUT].currencyId,
            recipient: null
        }));
        setResult({
            inputCurrencyId: parsed[actions/* Field.INPUT */.gN.INPUT].currencyId,
            outputCurrencyId: parsed[actions/* Field.OUTPUT */.gN.OUTPUT].currencyId
        });
    }, [
        dispatch,
        chainId,
        query
    ]);
    return result;
}
var useFetchPairPrices = function(param) {
    var token0Address = param.token0Address, token1Address = param.token1Address, timeWindow = param.timeWindow, currentSwapPrice = param.currentSwapPrice;
    var ref = (0,react.useState)(null), pairId = ref[0], setPairId = ref[1];
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var pairData = (0,es/* useSelector */.v9)(pairByDataIdSelector({
        pairId: pairId,
        timeWindow: timeWindow
    }));
    var derivedPairData = (0,es/* useSelector */.v9)(derivedPairByDataIdSelector({
        pairId: pairId,
        timeWindow: timeWindow
    }));
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        var fetchDerivedData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var derivedData, normalizedDerivedData;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            console.info("[Price Chart]: Not possible to retrieve price data from single pool, trying to fetch derived prices");
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return fetch_fetchDerivedPriceData(token0Address, token1Address, timeWindow);
                        case 4:
                            derivedData = _ctx.sent;
                            if (derivedData) {
                                normalizedDerivedData = normalizeDerivedChartData(derivedData);
                                dispatch((0,actions/* updateDerivedPairData */._U)({
                                    pairData: normalizedDerivedData,
                                    pairId: pairId,
                                    timeWindow: timeWindow
                                }));
                            } else {
                                dispatch((0,actions/* updateDerivedPairData */._U)({
                                    pairData: [],
                                    pairId: pairId,
                                    timeWindow: timeWindow
                                }));
                            }
                            _ctx.next = 12;
                            break;
                        case 8:
                            _ctx.prev = 8;
                            _ctx.t0 = _ctx["catch"](1);
                            console.error("Failed to fetch derived prices for chart", _ctx.t0);
                            dispatch((0,actions/* updateDerivedPairData */._U)({
                                pairData: [],
                                pairId: pairId,
                                timeWindow: timeWindow
                            }));
                        case 12:
                            _ctx.prev = 12;
                            setIsLoading(false);
                            return _ctx.finish(12);
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        8,
                        12,
                        15
                    ]
                ]);
            }));
            return function fetchDerivedData() {
                return _ref.apply(this, arguments);
            };
        }();
        var fetchAndUpdatePairPrice = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var data, hasEnoughLiquidity, newPairData;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setIsLoading(true);
                            _ctx.next = 3;
                            return fetch_fetchPairPriceData({
                                pairId: pairId,
                                timeWindow: timeWindow
                            });
                        case 3:
                            data = _ctx.sent.data;
                            if (data) {
                                hasEnoughLiquidity = pairHasEnoughLiquidity(data, timeWindow);
                                newPairData = normalizeChartData(data, timeWindow) || [];
                                if (newPairData.length > 0 && hasEnoughLiquidity) {
                                    dispatch((0,actions/* updatePairData */.Wk)({
                                        pairData: newPairData,
                                        pairId: pairId,
                                        timeWindow: timeWindow
                                    }));
                                    setIsLoading(false);
                                } else {
                                    console.info("[Price Chart]: Liquidity too low for ".concat(pairId));
                                    dispatch((0,actions/* updatePairData */.Wk)({
                                        pairData: [],
                                        pairId: pairId,
                                        timeWindow: timeWindow
                                    }));
                                    fetchDerivedData();
                                }
                            } else {
                                dispatch((0,actions/* updatePairData */.Wk)({
                                    pairData: [],
                                    pairId: pairId,
                                    timeWindow: timeWindow
                                }));
                                fetchDerivedData();
                            }
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetchAndUpdatePairPrice() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!pairData && !derivedPairData && pairId && !isLoading) {
            fetchAndUpdatePairPrice();
        }
    }, [
        pairId,
        timeWindow,
        pairData,
        currentSwapPrice,
        token0Address,
        token1Address,
        derivedPairData,
        dispatch,
        isLoading, 
    ]);
    (0,react.useEffect)(function() {
        var updatePairId = function() {
            try {
                var ref;
                var pairAddress = (ref = (0,getLpAddress/* default */.Z)(token0Address, token1Address)) === null || ref === void 0 ? void 0 : ref.toLowerCase();
                if (pairAddress !== pairId) {
                    setPairId(pairAddress);
                }
            } catch (error) {
                setPairId(null);
            }
        };
        updatePairId();
    }, [
        token0Address,
        token1Address,
        pairId
    ]);
    var normalizedPairData = (0,react.useMemo)(function() {
        return normalizePairDataByActiveToken({
            activeToken: token0Address,
            pairData: pairData
        });
    }, [
        token0Address,
        pairData
    ]);
    var normalizedDerivedPairData = (0,react.useMemo)(function() {
        return normalizeDerivedPairDataByActiveToken({
            activeToken: token0Address,
            pairData: derivedPairData
        });
    }, [
        token0Address,
        derivedPairData
    ]);
    var hasSwapPrice = currentSwapPrice && currentSwapPrice[token0Address] > 0;
    var normalizedPairDataWithCurrentSwapPrice = (normalizedPairData === null || normalizedPairData === void 0 ? void 0 : normalizedPairData.length) > 0 && hasSwapPrice ? (0,_to_consumable_array/* default */.Z)(normalizedPairData).concat([
        {
            time: new Date(),
            value: currentSwapPrice[token0Address]
        }
    ]) : normalizedPairData;
    var normalizedDerivedPairDataWithCurrentSwapPrice = (normalizedDerivedPairData === null || normalizedDerivedPairData === void 0 ? void 0 : normalizedDerivedPairData.length) > 0 && hasSwapPrice ? (0,_to_consumable_array/* default */.Z)(normalizedDerivedPairData).concat([
        {
            time: new Date(),
            value: currentSwapPrice[token0Address]
        }
    ]) : normalizedDerivedPairData;
    var hasNoDirectData = normalizedPairDataWithCurrentSwapPrice && (normalizedPairDataWithCurrentSwapPrice === null || normalizedPairDataWithCurrentSwapPrice === void 0 ? void 0 : normalizedPairDataWithCurrentSwapPrice.length) === 0;
    var hasNoDerivedData = normalizedDerivedPairDataWithCurrentSwapPrice && (normalizedDerivedPairDataWithCurrentSwapPrice === null || normalizedDerivedPairDataWithCurrentSwapPrice === void 0 ? void 0 : normalizedDerivedPairDataWithCurrentSwapPrice.length) === 0;
    // undefined is used for loading
    var pairPrices = hasNoDirectData && hasNoDerivedData ? [] : undefined;
    if (normalizedPairDataWithCurrentSwapPrice && (normalizedPairDataWithCurrentSwapPrice === null || normalizedPairDataWithCurrentSwapPrice === void 0 ? void 0 : normalizedPairDataWithCurrentSwapPrice.length) > 0) {
        pairPrices = normalizedPairDataWithCurrentSwapPrice;
    } else if (normalizedDerivedPairDataWithCurrentSwapPrice && (normalizedDerivedPairDataWithCurrentSwapPrice === null || normalizedDerivedPairDataWithCurrentSwapPrice === void 0 ? void 0 : normalizedDerivedPairDataWithCurrentSwapPrice.length) > 0) {
        pairPrices = normalizedDerivedPairDataWithCurrentSwapPrice;
    }
    return {
        pairPrices: pairPrices,
        pairId: pairId
    };
};
var useLPApr = function(pair) {
    var ref = (0,dist/* default */.Z)(pair && pair.chainId === src/* ChainId.BSC */.a_.BSC ? [
        "LP7dApr",
        pair.liquidityToken.address
    ] : null, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var timestampsArray, blocks, ref, block24h, block48h, block7d, block14d, ref1, error, data, formattedPoolData, formattedPoolData24h, formattedPoolData48h, formattedPoolData7d, formattedPoolData14d, current, oneDay, twoDays, week, twoWeeks, ref2, volumeUSD, ref3, volumeUSDWeek, liquidityUSD, lpApr7d;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    timestampsArray = (0,getDeltaTimestamps/* getDeltaTimestamps */.z)();
                    _ctx.next = 3;
                    return (0,getBlocksFromTimestamps/* getBlocksFromTimestamps */.z)(timestampsArray, "desc", 1000);
                case 3:
                    blocks = _ctx.sent;
                    ref = (0,_sliced_to_array/* default */.Z)(blocks !== null && blocks !== void 0 ? blocks : [], 4), block24h = ref[0], block48h = ref[1], block7d = ref[2], block14d = ref[3];
                    _ctx.next = 7;
                    return (0,pools_poolData/* fetchPoolData */.jf)(block24h.number, block48h.number, block7d.number, block14d.number, [
                        pair.liquidityToken.address.toLowerCase(), 
                    ]);
                case 7:
                    ref1 = _ctx.sent;
                    error = ref1.error;
                    data = ref1.data;
                    if (!error) {
                        _ctx.next = 12;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 12:
                    formattedPoolData = (0,pools_poolData/* parsePoolData */.l4)(data === null || data === void 0 ? void 0 : data.now);
                    formattedPoolData24h = (0,pools_poolData/* parsePoolData */.l4)(data === null || data === void 0 ? void 0 : data.oneDayAgo);
                    formattedPoolData48h = (0,pools_poolData/* parsePoolData */.l4)(data === null || data === void 0 ? void 0 : data.twoDaysAgo);
                    formattedPoolData7d = (0,pools_poolData/* parsePoolData */.l4)(data === null || data === void 0 ? void 0 : data.oneWeekAgo);
                    formattedPoolData14d = (0,pools_poolData/* parsePoolData */.l4)(data === null || data === void 0 ? void 0 : data.twoWeeksAgo);
                    current = formattedPoolData[pair.liquidityToken.address.toLowerCase()];
                    oneDay = formattedPoolData24h[pair.liquidityToken.address.toLowerCase()];
                    twoDays = formattedPoolData48h[pair.liquidityToken.address.toLowerCase()];
                    week = formattedPoolData7d[pair.liquidityToken.address.toLowerCase()];
                    twoWeeks = formattedPoolData14d[pair.liquidityToken.address.toLowerCase()];
                    ref2 = (0,_sliced_to_array/* default */.Z)((0,getChangeForPeriod/* getChangeForPeriod */.T)(current === null || current === void 0 ? void 0 : current.volumeUSD, oneDay === null || oneDay === void 0 ? void 0 : oneDay.volumeUSD, twoDays === null || twoDays === void 0 ? void 0 : twoDays.volumeUSD), 1), volumeUSD = ref2[0];
                    ref3 = (0,_sliced_to_array/* default */.Z)((0,getChangeForPeriod/* getChangeForPeriod */.T)(current === null || current === void 0 ? void 0 : current.volumeUSD, week === null || week === void 0 ? void 0 : week.volumeUSD, twoWeeks === null || twoWeeks === void 0 ? void 0 : twoWeeks.volumeUSD), 1), volumeUSDWeek = ref3[0];
                    liquidityUSD = current ? current.reserveUSD : 0;
                    lpApr7d = (0,getLpFeesAndApr/* getLpFeesAndApr */.z)(volumeUSD, volumeUSDWeek, liquidityUSD).lpApr7d;
                    return _ctx.abrupt("return", lpApr7d ? {
                        lpApr7d: lpApr7d
                    } : null);
                case 27:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), {
        refreshInterval: constants/* SLOW_INTERVAL */.KI
    }), poolData = ref.data;
    return poolData;
};


/***/ }),

/***/ 5549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ PairDataTimeWindowEnum; }
/* harmony export */ });
var PairDataTimeWindowEnum;
(function(PairDataTimeWindowEnum) {
    PairDataTimeWindowEnum[PairDataTimeWindowEnum["DAY"] = 0] = "DAY";
    PairDataTimeWindowEnum[PairDataTimeWindowEnum["WEEK"] = 1] = "WEEK";
    PairDataTimeWindowEnum[PairDataTimeWindowEnum["MONTH"] = 2] = "MONTH";
    PairDataTimeWindowEnum[PairDataTimeWindowEnum["YEAR"] = 3] = "YEAR";
})(PairDataTimeWindowEnum || (PairDataTimeWindowEnum = {}));


/***/ }),

/***/ 95271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ useSwapActionHandlers; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82670);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54346);
/* harmony import */ var _actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70193);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31318);





function useSwapActionHandlers() {
    var dispatch = (0,_index__WEBPACK_IMPORTED_MODULE_3__/* .useAppDispatch */ .TL)();
    var onSwitchTokens = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_2__/* .switchCurrencies */ .KS)());
    }, [
        dispatch
    ]);
    var onCurrencySelection = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(field, currency) {
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_2__/* .selectCurrency */ .j)({
            field: field,
            currencyId: (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(currency, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .Token */ .WU) ? currency.address : currency === _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .ETHER */ .c0 ? "PLS" : ""
        }));
    }, [
        dispatch
    ]);
    var onUserInput = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(field, typedValue) {
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_2__/* .typeInput */ .LC)({
            field: field,
            typedValue: typedValue
        }));
    }, [
        dispatch
    ]);
    var onChangeRecipient = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(recipient) {
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_2__/* .setRecipient */ .He)({
            recipient: recipient
        }));
    }, [
        dispatch
    ]);
    return {
        onSwitchTokens: onSwitchTokens,
        onCurrencySelection: onCurrencySelection,
        onUserInput: onUserInput,
        onChangeRecipient: onChangeRecipient
    };
}


/***/ }),

/***/ 71900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K5": function() { return /* binding */ useCurrencyBalances; },
/* harmony export */   "Z": function() { return /* binding */ useTokenBalances; },
/* harmony export */   "_h": function() { return /* binding */ useCurrencyBalance; },
/* harmony export */   "mM": function() { return /* binding */ useTokenBalance; },
/* harmony export */   "uD": function() { return /* binding */ useAllTokenBalances; },
/* harmony export */   "v2": function() { return /* binding */ useTokenBalancesWithLoadingIndicator; }
/* harmony export */ });
/* unused harmony export useBNBBalances */
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82670);
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54346);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _web3_react_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77044);
/* harmony import */ var config_abi_erc20__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85169);
/* harmony import */ var hooks_Tokens__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86435);
/* harmony import */ var hooks_useContract__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5039);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93293);
/* harmony import */ var lodash_orderBy__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75472);
/* harmony import */ var lodash_orderBy__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash_orderBy__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _multicall_hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(91001);










/**
 * Returns a map of the given addresses to their eventually consistent PLS balances.
 */ function useBNBBalances(uncheckedAddresses) {
    var multicallContract = (0,hooks_useContract__WEBPACK_IMPORTED_MODULE_5__/* .useMulticallContract */ .gq)();
    var addresses = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return uncheckedAddresses ? lodash_orderBy__WEBPACK_IMPORTED_MODULE_7___default()(uncheckedAddresses.map(utils__WEBPACK_IMPORTED_MODULE_6__/* .isAddress */ .UJ).filter(function(a) {
            return a !== false;
        })) : [];
    }, [
        uncheckedAddresses
    ]);
    var results = (0,_multicall_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useSingleContractMultipleData */ .es)(multicallContract, "getEthBalance", (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return addresses.map(function(address) {
            return [
                address
            ];
        });
    }, [
        addresses
    ]));
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return addresses.reduce(function(memo, address, i) {
            var ref, ref1;
            var value = results === null || results === void 0 ? void 0 : (ref = results[i]) === null || ref === void 0 ? void 0 : (ref1 = ref.result) === null || ref1 === void 0 ? void 0 : ref1[0];
            if (value) memo[address] = _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.ether */ .ih.ether(_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.BigInt */ .QA.BigInt(value.toString()));
            return memo;
        }, {});
    }, [
        addresses,
        results
    ]);
}
/**
 * Returns a map of token addresses to their eventually consistent token balances for a single account.
 */ function useTokenBalancesWithLoadingIndicator(address, tokens) {
    var ref;
    var validatedTokens = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (ref = tokens === null || tokens === void 0 ? void 0 : tokens.filter(function(t) {
            return (0,utils__WEBPACK_IMPORTED_MODULE_6__/* .isAddress */ .UJ)(t === null || t === void 0 ? void 0 : t.address) !== false;
        })) !== null && ref !== void 0 ? ref : [];
    }, [
        tokens
    ]);
    var validatedTokenAddresses = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return validatedTokens.map(function(vt) {
            return vt.address;
        });
    }, [
        validatedTokens
    ]);
    var balances = (0,_multicall_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useMultipleContractSingleData */ ._Y)(validatedTokenAddresses, config_abi_erc20__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, "balanceOf", (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return [
            address
        ];
    }, [
        address
    ]));
    var anyLoading = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return balances.some(function(callState) {
            return callState.loading;
        });
    }, [
        balances
    ]);
    return [
        (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
            return address && validatedTokens.length > 0 ? validatedTokens.reduce(function(memo, token, i) {
                var ref, ref1;
                var value = balances === null || balances === void 0 ? void 0 : (ref = balances[i]) === null || ref === void 0 ? void 0 : (ref1 = ref.result) === null || ref1 === void 0 ? void 0 : ref1[0];
                var amount = value ? _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.BigInt */ .QA.BigInt(value.toString()) : undefined;
                if (amount) {
                    memo[token.address] = new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .TokenAmount */ .dt(token, amount);
                }
                return memo;
            }, {}) : {};
        }, [
            address,
            validatedTokens,
            balances
        ]),
        anyLoading, 
    ];
}
function useTokenBalances(address, tokens) {
    return useTokenBalancesWithLoadingIndicator(address, tokens)[0];
}
// get the balance for a single token/account combo
function useTokenBalance(account, token) {
    var tokenBalances = useTokenBalances(account, [
        token
    ]);
    if (!token) return undefined;
    return tokenBalances[token.address];
}
function useCurrencyBalances(account, currencies) {
    var ref;
    var tokens = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (ref = currencies === null || currencies === void 0 ? void 0 : currencies.filter(function(currency) {
            return (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(currency, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Token */ .WU);
        })) !== null && ref !== void 0 ? ref : [];
    }, [
        currencies
    ]);
    var tokenBalances = useTokenBalances(account, tokens);
    var ref1;
    var containsBNB = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (ref1 = currencies === null || currencies === void 0 ? void 0 : currencies.some(function(currency) {
            return currency === _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ETHER */ .c0;
        })) !== null && ref1 !== void 0 ? ref1 : false;
    }, [
        currencies
    ]);
    var uncheckedAddresses = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return containsBNB ? [
            account
        ] : [];
    }, [
        containsBNB,
        account
    ]);
    var bnbBalance = useBNBBalances(uncheckedAddresses);
    var ref2;
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (ref2 = currencies === null || currencies === void 0 ? void 0 : currencies.map(function(currency) {
            if (!account || !currency) return undefined;
            if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(currency, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Token */ .WU)) return tokenBalances[currency.address];
            if (currency === _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ETHER */ .c0) return bnbBalance[account];
            return undefined;
        })) !== null && ref2 !== void 0 ? ref2 : [];
    }, [
        account,
        currencies,
        bnbBalance,
        tokenBalances
    ]);
}
function useCurrencyBalance(account, currency) {
    return useCurrencyBalances(account, [
        currency
    ])[0];
}
// mimics useAllBalances
function useAllTokenBalances() {
    var account = (0,_web3_react_core__WEBPACK_IMPORTED_MODULE_2__/* .useWeb3React */ .Ge)().account;
    var allTokens = (0,hooks_Tokens__WEBPACK_IMPORTED_MODULE_4__/* .useAllTokens */ .e_)();
    var allTokensArray = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return Object.values(allTokens !== null && allTokens !== void 0 ? allTokens : {});
    }, [
        allTokens
    ]);
    var balances = useTokenBalances(account !== null && account !== void 0 ? account : undefined, allTokensArray);
    return balances !== null && balances !== void 0 ? balances : {};
}


/***/ }),

/***/ 32323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82670);
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54346);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93293);



var getLpAddress = function(token1, token2) {
    var chainId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.BSC */ .a_.BSC;
    var token1AsTokenInstance = token1;
    var token2AsTokenInstance = token2;
    if (!token1 || !token2) {
        return null;
    }
    if (typeof token1 === "string" || (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(token1, String)) {
        var checksummedToken1Address = (0,utils__WEBPACK_IMPORTED_MODULE_1__/* .isAddress */ .UJ)(token1);
        if (!checksummedToken1Address) {
            return null;
        }
        token1AsTokenInstance = new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Token */ .WU(chainId, checksummedToken1Address, 18);
    }
    if (typeof token2 === "string" || (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(token2, String)) {
        var checksummedToken2Address = (0,utils__WEBPACK_IMPORTED_MODULE_1__/* .isAddress */ .UJ)(token2);
        if (!checksummedToken2Address) {
            return null;
        }
        token2AsTokenInstance = new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Token */ .WU(chainId, checksummedToken2Address, 18);
    }
    return _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Pair.getAddress */ .sO.getAddress(token1AsTokenInstance, token2AsTokenInstance);
};
/* harmony default export */ __webpack_exports__["Z"] = (getLpAddress);


/***/ }),

/***/ 90570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ uriToHttp; }
/* harmony export */ });
/* eslint-disable no-case-declarations */ /**
 * Given a URI that may be ipfs, ipns, http, or https protocol, return the fetch-able http(s) URLs for the same content
 * @param uri to convert to fetch-able http url
 */ function uriToHttp(uri) {
    var protocol = uri.split(":")[0].toLowerCase();
    switch(protocol){
        case "https":
            return [
                uri
            ];
        case "http":
            return [
                "https".concat(uri.substring(4)),
                uri
            ];
        case "ipfs":
            var ref;
            var hash = (ref = uri.match(/^ipfs:(\/\/)?(.*)$/i)) === null || ref === void 0 ? void 0 : ref[2];
            return [
                "https://cloudflare-ipfs.com/ipfs/".concat(hash, "/"),
                "https://ipfs.io/ipfs/".concat(hash, "/")
            ];
        case "ipns":
            var ref1;
            var name = (ref1 = uri.match(/^ipns:(\/\/)?(.*)$/i)) === null || ref1 === void 0 ? void 0 : ref1[2];
            return [
                "https://cloudflare-ipfs.com/ipns/".concat(name, "/"),
                "https://ipfs.io/ipns/".concat(name, "/")
            ];
        default:
            return [];
    }
};


/***/ }),

/***/ 49438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87379);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4318);
/* harmony import */ var components_Layout_Page__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83559);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3862);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  padding: ",
        ";\n  padding-bottom: 0;\n  min-height: ",
        ";\n  // background: ",
        ";\n\n  ",
        " {\n    background-size: auto;\n  }\n\n  ",
        " {\n    padding: ",
        ";\n    padding-bottom: 0;\n  }\n\n  ",
        " {\n    padding: ",
        ";\n    padding-bottom: 0;\n    min-height: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* eslint-disable @typescript-eslint/no-unused-vars */ 



var StyledPage = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b1bc8c2c-0"
})(_templateObject(), function(param) {
    var $removePadding = param.$removePadding;
    return $removePadding ? "0" : "16px";
}, function(param) {
    var $noMinHeight = param.$noMinHeight;
    return $noMinHeight ? "initial" : "calc(100vh - 64px)";
}, function(param) {
    var theme = param.theme;
    return theme.colors.gradients.bubblegum;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xs;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var $removePadding = param.$removePadding;
    return $removePadding ? "0" : "24px";
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
}, function(param) {
    var $removePadding = param.$removePadding;
    return $removePadding ? "0" : "32px";
}, function(param) {
    var $noMinHeight = param.$noMinHeight;
    return $noMinHeight ? "initial" : "calc(100vh - 100px)";
});
var Page = function(_param) {
    var children = _param.children, _removePadding = _param.removePadding, removePadding = _removePadding === void 0 ? false : _removePadding, _hideFooterOnDesktop = _param.hideFooterOnDesktop, hideFooterOnDesktop = _hideFooterOnDesktop === void 0 ? false : _hideFooterOnDesktop, _noMinHeight = _param.noMinHeight, noMinHeight = _noMinHeight === void 0 ? false : _noMinHeight, _helpUrl = _param.helpUrl, helpUrl = _helpUrl === void 0 ? config_constants__WEBPACK_IMPORTED_MODULE_3__/* .EXCHANGE_DOCS_URLS */ .SO : _helpUrl, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "children",
        "removePadding",
        "hideFooterOnDesktop",
        "noMinHeight",
        "helpUrl"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Layout_Page__WEBPACK_IMPORTED_MODULE_2__/* .PageMeta */ .V, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledPage, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                $removePadding: removePadding,
                $noMinHeight: noMinHeight
            }, props), {
                children: [
                    children,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        flexGrow: 1
                    })
                ]
            }))
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Page);


/***/ }),

/***/ 59298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ BNB_ADDRESS; }
/* harmony export */ });
// PLS Address
var BNB_ADDRESS = "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c";



/***/ }),

/***/ 69197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ getTokenAddress; },
/* harmony export */   "E": function() { return /* binding */ getTimeWindowChange; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59298);

var MIN_VALUE_DISPLAYED = 0.001;
var getTimeWindowChange = function(lineChartData) {
    if (lineChartData.length > 0) {
        var ref;
        var ref1;
        var firstValue = (ref1 = (ref = lineChartData.find(function(param) {
            var value = param.value;
            return !!value && value > 0;
        })) === null || ref === void 0 ? void 0 : ref.value) !== null && ref1 !== void 0 ? ref1 : 0;
        var lastValue = lineChartData[lineChartData.length - 1].value;
        var changeValue = lastValue - firstValue;
        return {
            changeValue: changeValue > 0 ? Math.max(changeValue, MIN_VALUE_DISPLAYED) : Math.min(changeValue, MIN_VALUE_DISPLAYED * -1),
            changePercentage: (changeValue / firstValue * 100).toFixed(2)
        };
    }
    return {
        changeValue: 0,
        changePercentage: 0
    };
};
var getTokenAddress = function(tokenAddress) {
    if (!tokenAddress) {
        return "";
    }
    var lowerCaseAddress = tokenAddress.toLowerCase();
    if (lowerCaseAddress === "bnb") {
        return _constants__WEBPACK_IMPORTED_MODULE_0__/* .BNB_ADDRESS */ .I;
    }
    return lowerCaseAddress;
};


/***/ })

}]);